import { Url } from 'finhelper';
import { Api } from 'laravel-request';
import React, { useState, useEffect, ReactNode } from 'react';

import HeaderLanding from '#app/interface/landing/header/Header';

import UnexpectedError from './UnexpectedError';

interface ErrorInfo {
  error: Error;
  info: React.ErrorInfo;
}

interface ErrorBoundaryProps {
  children?: ReactNode;
}

const ErrorBoundary: React.FC<ErrorBoundaryProps> = ({ children }) => {
  const [hasError, setHasError] = useState(false);
  const [errorInfo, setErrorInfo] = useState<ErrorInfo | null>(null);

  useEffect(() => {
    if (errorInfo) {
      const logError = async () => {
        try {
          const url = Url.getCurrentUrl();
          await Api.post('error-log', 'store', {
            message: errorInfo.error.message,
            trace: errorInfo.error.stack,
            url,
            info: errorInfo.info,
          }).call();
        } catch (e) {
          console.error('Failed to log error:', e);
        }
      };
      logError();
    }
  }, [errorInfo]);

  const _handleError = (error: Error, info: React.ErrorInfo) => {
    setHasError(true);
    setErrorInfo({ error, info });
  };

  if (hasError) {
    return (
      <>
        <HeaderLanding />
        <UnexpectedError />
      </>
    );
  }

  return <>{children}</>;
};

(ErrorBoundary as any as { getDerivedStateFromError: (error: Error) => { hasError: boolean } }).getDerivedStateFromError = () => ({
  hasError: true,
});

const ErrorBoundaryWrapper: React.FC<ErrorBoundaryProps> = (props) => (
  <ErrorBoundary {...props}>{props.children}</ErrorBoundary>
);

export default ErrorBoundaryWrapper;
